module.exports = __webpack_public_path__ + "static/img/Image_002.42773f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/Image_002.png
// module id = AYro
// module chunks = 3